import React, { useContext, useEffect, useState, useRef } from 'react'
import openSocket from 'socket.io-client'
import dayjs from 'dayjs'
import * as Yup from 'yup'
import './Draft.css'
import 'react-tagsinput/react-tagsinput.css'
import { useFormik } from 'formik'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { useTheme } from '@mui/material/styles'
import {
    Button,
    Checkbox,
    FormControl,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
    InputAdornment,
    Tooltip,
} from '@mui/material'
// import ShowMoreText from 'react-show-more-text'
// import Linkify from 'react-linkify'
import TagsInput from 'react-tagsinput'
import EditModal from './EditModal'
import FilterModal from './FilterModal'
import LineClampItem from './LineClampItem'
import { mapData } from '@/product/common/components'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommentModal from './CommentModal'
import Loaders from '@/product/components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'
import reportContext from '@/product/context/report/reportContext'
import ProductContext from '@/product/context/product/productContext'
import EmployeeContext from '@/product/context/employee/empContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { initialFilterFunction } from '@/product/components/species/dynamic/common/FieldFunction'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { Pagination } from '@mui/material'
import {
    dateTimeFormatFunction,
    isValidHttpUrl,
} from '../../../custom/common/components'
import ImageZoom from '@/custom/components/organisms/ImageZoom'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

const inventoryStatus = ['Live', 'Fix', 'Ready', 'Pending', 'Delete']

const updateStatus = [
    'Action',
    'Update Status',
    'Update End Time',
    'Keyword Tags',
    'Export',
]

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    }
}

const ListingTable = (props) => {
    const from = `newDraftListing`
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)
    const { getAllExportDownload } = useContext(reportContext)
    const employeeContext = useContext(EmployeeContext)
    const authContext = useContext(AuthContext)
    const { isAdmin, user } = authContext
    const { draft_page_filters, updateDraftPageFilters } =
        useContext(CustomCommonContext)
    const {
        all_products,
        getAllProducts,
        changeProductStatus,
        multiProjectAction,
        responseStatus: responseStatusProduct,
    } = productContext
    const { setAlert } = alertContext
    const { all_employees, getAllEmployees } = employeeContext
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } }
    const theme = useTheme()
    const [personName, setPersonName] = useState('')
    const { action } = useParams()
    const [arrayValue, setArrayValue] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [commentPopup, setCommentPopup] = useState(false)
    const [initialValues, setInitialValues] = useState({})
    const [filterArray, setFilterArray] = useState({})
    const [initialUpdate, setInitialUpdate] = useState(true)
    const [searchProduct, setSearchProduct] = useState(false)
    const [imageZoomModal, setImageZoomModal] = useState(false)
    const [images, setImages] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [allProducts, setAllProducts] = useState([])
    const [productDetails, setProductDetails] = useState({})
    const [editModal, setEditModal] = useState(false)
    const [filterModal, setFilterModal] = useState(false)
    const [prevID, setPrevID] = useState(null)
    const [nextID, setNextID] = useState(null)
    const [checkboxes, setCheckboxes] = useState([])
    const [selectedStatus, setSelectedStatus] = useState('Live')
    const [internalStatusObj, setInternalStatusObj] = useState({
        id: 0,
        status: '',
        item_id: '',
        bprice: 0,
        asin_price: 0,
        date_closed: null,
    })
    const [selectedStagger, setSelectedStagger] = useState({
        type: 'mins',
        value: 1,
    })
    const [itemTags, setItemTags] = useState([])
    const [itemNum, setItemNum] = useState('10')
    const [bulkClosedDate, setBulkClosedDate] = useState({
        end_date: dayjs().format('YYYY-MM-DD'),
        end_time: dayjs().format('HH:mm:ss'),
    })
    const [selectedFilters, setSelectedFilters] = useState({
        status: {},
        sort: '',
        // source: {},
        location: {},
        processor: {},
    })
    const [scrollIndex, setScrollIndex] = useState(null)
    const rowRefs = useRef([])

    const internalStatusObject = {
        'Draft Listings': 'live',
        'Fix Listings': 'fix',
        'Ready Listings': 'ready',
        'Pending Listings': 'pending',
        'Deleted Listings': 'delete',
    }

    const orderByObject = {
        'Retail Price High to Low': 'it.asin_price, desc',
        'Retail Price Low to High': 'it.asin_price, asc',
        'Recently Added A-Z': 'p.created_at, desc',
        'Recently Added Z-A': 'p.created_at, asc',
        'Buy Now High to Low': 'p.bprice, desc',
        'Buy Now Low to High': 'p.bprice, asc',
        'Ending Soonest': 'p.date_closed, asc',
        'Ending Furthest': 'p.date_closed, desc',
        'Recently Updated A-Z': 'p.updated_at, desc',
        'Recently Updated Z-A': 'p.updated_at, asc',
    }

    const handleBulkDateChange = (field, newValue) => {
        if (!newValue || !dayjs(newValue).isValid()) {
            console.error('Invalid date value passed:', newValue)
            return
        }

        setBulkClosedDate((prev) => ({
            ...prev,
            [field]:
                field === 'end_date'
                    ? dayjs(newValue).format('YYYY-MM-DD')
                    : dayjs(newValue).format('HH:mm:ss'),
        }))
    }

    const sortOptions = {}

    // useEffect(() => {
    //     const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
    //         transports: ['websocket'],
    //     })
    //     socket.on('draftInventory', (data) => {
    //         setAlert(`Lot ${data}`, `info`)
    //     })
    // }, [])

    const formik = useFormik({
        initialValues: draft_page_filters,
        // limitOptions: null,
        enableReinitialize: true,
        onSubmit: (values) => {
            updateDraftPageFilters(values)
            setIsLoading(true)
            getAllProducts(values, from, 'formikOnSubmit')
        },
    })

    const validationForStatusChange = Yup.object({
        item_id: Yup.string().required('Please Select a valid Item ID'),
        end_date: Yup.date()
            .required('Please select a valid End Date')
            .typeError('Please select a valid End Date'),
        end_time: Yup.string()
            .required('Please select a valid End Time')
            .typeError('Please select a valid End Time'),
        // bprice: Yup.number().required('Please enter a valid Buynow Price'),
        //  asin_price: Yup.number().required('Please enter a valid Retail Price'),
    })

    const validateChangeStatusformik = async () => {
        const errors = await changeStatusformik.validateForm()
        if (Object.keys(errors).length > 0) {
            throwAlert(Object.values(errors)[0])
        }
        return true
    }

    const changeStatusformik = useFormik({
        initialValues: {
            action: 'open',
            project_id: '',
            end_date: null,
            end_time: null,
            bprice: 0,
            item_id: '',
            date_closed: null,
        },
        enableReinitialize: true,
        validationSchema: validationForStatusChange,
        onSubmit: async (values) => {
            console.log(`changeStatusformik onSubmit `, values)
            setIsLoading(true)
            changeProductStatus(values, `moveItemToLive`, true)
        },
    })

    // const multiProjectFormik = useFormik({
    //     initialValues: {
    //         action: 'statusUpdate',
    //         project_id: [],
    //         status: '',
    //         comments: '',
    //     },
    //     validationSchema: Yup.object({
    //         project_id: Yup.array()
    //             .min(1, 'Select atleast one lot')
    //             .required('Project IDs are required'),
    //     }),
    //     onSubmit: (values) => {
    //         console.log(`multiProjectFormik formData `, values)
    //         // multiProjectAction(values, from, true)
    //     },
    // })

    const internalStatusFormik = useFormik({
        initialValues: {
            action: 'internal_status',
            project_id: [],
            item_id: '',
            asin_price: 0,
            bprice: 0,
            status: '',
            notes: '',
            column: 'status',
            mainUpdate: false,
            keywords: [],
        },
        validationSchema: Yup.object({
            notes: Yup.string(),
            // .when('status', {
            //     is: (status) => status === 'fix',
            //     then: Yup.string().required('Required!'),
            //     otherwise: Yup.string(),
            // }),
        }),
        onSubmit: (values) => {
            console.log('internalStatusFormik formData Parent ', values)
            values.buynow = Number(values.bprice) > 0 ? 1 : 0
            changeProductStatus(values, 'internalStatusChange', true)
        },
    })

    const commentsData = [
        {
            label: 'Notes',
            name: 'notes',
            type: 'textarea',
            placeholder: 'Enter Lot Notes',
            formik: internalStatusFormik,
        },
    ]

    // useEffect(() => {
    //     getAllEmployees({ limit: 100 })
    //     setInitialValues({})
    //     setInitialUpdate(true)

    //     if (props.searchInfo?.data && props.searchInfo?.data.length) {
    //         let mapValueArray = props.searchInfo?.data
    //         let show = initialFilterFunction(mapValueArray)
    //         setInitialValues({ ...props.customFilter, ...show })
    //         setFilterArray(props.searchInfo)
    //         console.log(`searchProduct `, show)
    //         formik.setFieldValue('filters', { ...props.customFilter, ...show })
    //         setTimeout(() => {
    //             if (Object.keys(show).length) {
    //                 setSearchProduct(true)
    //                 setInitialUpdate(false)
    //             }
    //         }, 1000)
    //     } else {
    //         setInitialValues(props.customFilter)
    //         setTimeout(() => {
    //             if (Object.keys(props.customFilter || {}).length) {
    //                 setSearchProduct(true)
    //                 setInitialUpdate(false)
    //             }
    //         }, 1000)
    //     }
    //     setInitialUpdate(false)
    // }, [])

    useEffect(() => {
        getAllEmployees({
            page: 1,
            limit: 100,
            order: '',
            orderby: '',
            filters: {
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_email,e.emp_firstname,e.emp_lastname',
                },
                emp_firstname: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_firstname',
                },
                emp_lastname: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_lastname',
                },
                emp_type: {
                    value: '',
                    type: 'in',
                    field: 'e.emp_type',
                },
                status: {
                    value: '',
                    type: 'in',
                    field: 'e.emp_status',
                },
                emp_location: {
                    value: [],
                    type: 'array',
                    field: 'e.emp_location',
                },
            },
        })
        setInitialValues({})
        setInitialUpdate(true)

        setTimeout(() => {
            setInitialUpdate(false)
        }, 500)
        setSearchProduct(true)
    }, [])

    const getProductsWithLatestFilters = (
        fromVariable = from,
        pagereset = false
    ) => {
        const combinedFilters = {
            ...formik.values,
            page: pagereset ? 1 : formik.values.page,
            filters: {
                ...props.searchFormik.values.filters,
                ...formik.values.filters,
            },
        }
        updateDraftPageFilters({ ...draft_page_filters, ...combinedFilters })
        getAllProducts(
            combinedFilters,
            fromVariable,
            'formik_getProductsWithLatestFilters'
        )
    }

    useEffect(() => {
        if (searchProduct) {
            getProductsWithLatestFilters(from)
        }
    }, [searchProduct])

    const handleClickMyModal = (index) => {
        if (editModal) {
            setProductDetails({})
            setIsLoading(true)
            getProductsWithLatestFilters(from)
            setScrollIndex(index)
        }
        setEditModal(!editModal)
    }

    useEffect(() => {
        if (
            !isLoading &&
            scrollIndex !== null &&
            rowRefs.current[scrollIndex]
        ) {
            rowRefs.current[scrollIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
            setScrollIndex(null)
        }
    }, [isLoading, scrollIndex])

    const searchInfo = filterArray.data?.length
        ? { formik: formik, ...filterArray }
        : { formik: formik }

    const nextInternalStatus = {
        live: 'fix',
        ready: 'fix',
        fix: 'pending',
        pending: 'live',
    }

    const closeCommentPopup = () => setCommentPopup(false)

    const changeCommentPopup = (e, id, current, productDetails) => {
        e.preventDefault()
        if (id) {
            const endDate = dayjs(productDetails.end_date).format('YYYY-MM-DD')
            const endTime = dayjs(productDetails.end_time, 'hh:mm:ss a').format(
                'HH:mm:ss'
            )
            const validDateClosed = dayjs(`${endDate}T${endTime}`).format(
                'YYYY-MM-DDTHH:mm:ssZ'
            )
            const date_closed = dayjs(validDateClosed).isValid()
                ? validDateClosed
                : null

            const status = nextInternalStatus[current]
            const { item_id, bprice, asin_price } = productDetails
            setInternalStatusObj({
                id,
                status,
                item_id,
                bprice,
                asin_price,
                date_closed,
            })
            if (current === 'live' || current === 'ready') {
                setCommentPopup(true)
            } else {
                internalStatusFormik.setFieldValue(`project_id`, [id])
                internalStatusFormik.setFieldValue(`status`, status)
                internalStatusFormik.setFieldValue(`item_id`, item_id)
                internalStatusFormik.setFieldValue(`bprice`, bprice)
                internalStatusFormik.setFieldValue(`asin_price`, asin_price)
                if (date_closed)
                    internalStatusFormik.setFieldValue(
                        `date_closed`,
                        date_closed
                    )
                internalStatusFormik.handleSubmit()
            }
        } else {
            internalStatusFormik.resetForm()
            setCommentPopup(false)
        }

        // if (id) {
        //     internalStatusFormik.setFieldValue(`project_id`, [id])
        //     internalStatusFormik.setFieldValue(
        //         `status`,
        //         nextInternalStatus[status]
        //     )
        //     if (status === 'live') {
        //         setCommentPopup(true)
        //     } else {
        //         internalStatusFormik.handleSubmit()
        //     }
        // } else {
        //     internalStatusFormik.resetForm()
        //     setCommentPopup(false)
        // }
    }

    useEffect(() => {
        if (all_products?.from === from) {
            const updatedRecords = all_products.records.map((record) => {
                const date = record.date_closed
                    ? dayjs(record.date_closed)
                    : null
                // : dayjs()
                return {
                    ...record,
                    end_date: date?.format('YYYY-MM-DD'),
                    end_time: date?.format('HH:mm:ss a'),
                }
            })
            setAllProducts(updatedRecords)
            setCheckboxes(
                updatedRecords.reduce((acc, _, index) => {
                    acc[index] = false
                    return acc
                }, {})
            )
            setIsLoading(false)
        }
    }, [all_products])

    useEffect(() => {
        if (all_products?.from !== from) {
            return
        }

        const totalRecords = Number(all_products.totalRecords) || 0
        const totalPages = Math.max(
            1,
            Math.ceil(totalRecords / formik.values.limit)
        )

        if (formik.values.page > totalPages) {
            formik.setFieldValue('page', totalPages)
        }
    }, [
        all_products?.from,
        all_products?.totalRecords,
        formik.values.limit,
        formik.values.page,
    ])

    useEffect(() => {
        if (props.isLoading) setIsLoading(true)
    }, [props.isLoading])

    const onClickPreview = (id, type) => {
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${id}`,
            // `http://localhost:3000/productView/${id}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    useEffect(() => {
        if (!initialUpdate) {
            setIsLoading(true)
            getProductsWithLatestFilters(from)
        }
    }, [formik.values.page])

    useEffect(() => {
        if (!initialUpdate) {
            setIsLoading(true)
            getProductsWithLatestFilters(from, true)
        }
    }, [formik.values.limit])

    useEffect(() => {
        if (props.tableValue.length) {
            let dynamicValueAssign = props.tableValue
            if (action !== 'sold' && action !== 'relisted') {
                dynamicValueAssign = dynamicValueAssign.filter(
                    (item) =>
                        item.field !== 'action' &&
                        item.field !== 'winner_email' &&
                        item.field !== 'buynow_common_invoice' &&
                        item.field !== 'buynow_paid_date' &&
                        item.field !== 'buynow_qty' &&
                        item.field !== 'buynow_amount' &&
                        item.field !== 'winner_first_name,winner_last_name'
                )
            }
            let index = dynamicValueAssign.findIndex((e) => e.field == 'action')
            let arrayVal = []
            if (!props.show_dashboard_values && !props.noaction) {
                if (index > 0) {
                    arrayVal = dynamicValueAssign.filter(
                        (item) => item.field !== 'action'
                    )
                    arrayVal.push({
                        name: 'action',
                        field: 'action',
                        type: 'button',
                        isMultiple: true,
                        clickID: 'id',
                        sort: false,
                        firstChild: false,
                        disablePadding: false,
                        label: 'Action',
                        // isMultiple: getMultipleAction(),
                        tableShow: 1,
                    })
                } else {
                    arrayVal = dynamicValueAssign
                    arrayVal.push({
                        name: 'action',
                        field: 'action',
                        type: 'button',
                        isMultiple: true,
                        clickID: 'id',
                        sort: false,
                        firstChild: false,
                        disablePadding: false,
                        label: 'Action',
                        // isMultiple: getMultipleAction(),
                        tableShow: 1,
                    })
                }
                setArrayValue(arrayVal)
            } else {
                setArrayValue(dynamicValueAssign)
            }
        }
    }, [props.tableValue, action])

    const getPrevAndNextProductID = (id) => {
        const index = allProducts.findIndex((product) => product.id === id)
        if (index === -1) {
            return { prev: null, next: null }
        }

        const prev = index > 0 ? allProducts[index - 1]?.id : null
        const next =
            index < allProducts.length - 1 ? allProducts[index + 1]?.id : null

        return { prev, next }
    }

    const handleModalChanges = (productDetails) => {
        const { prev, next } = getPrevAndNextProductID(productDetails.id)
        setPrevID(prev)
        setNextID(next)
        setProductDetails(productDetails)
        setTimeout(() => {
            setEditModal(true)
        }, 500)
    }

    useEffect(() => {
        if (responseStatusProduct?.status === 'success') {
            if (
                responseStatusProduct?.from === from ||
                responseStatusProduct?.from === 'multiProjectAction'
            ) {
                setItemTags([])
                setPersonName('')
                // setIsLoading(false)
                setIsLoading(true)
                getProductsWithLatestFilters(from)
            } else if (responseStatusProduct?.from === 'draftListingPopup') {
                if (
                    Object.keys(responseStatusProduct?.data?.single_project)
                        .length > 0
                ) {
                    const dateClosed =
                        responseStatusProduct.data.single_project.date_closed
                    const product = {
                        ...responseStatusProduct.data.single_project,
                        end_date: dateClosed
                            ? dayjs(dateClosed).format('YYYY-MM-DD')
                            : dayjs().format('YYYY-MM-DD'),
                        end_time: dateClosed
                            ? dayjs(dateClosed).format('HH:mm:ss a')
                            : dayjs().format('HH:mm:ss a'),
                    }
                    handleModalChanges(product)
                }
            } else if (responseStatusProduct?.from === 'moveItemToLive') {
                getProductsWithLatestFilters(from)
            }
        }
        if (responseStatusProduct?.from === 'internalStatusChange') {
            setCommentPopup(false)
            setInternalStatusObj({ id: 0, status: null })
            getProductsWithLatestFilters(from)
        }
    }, [responseStatusProduct])

    const statusString = {
        live: 'Redo',
        ready: 'Redo',
        fix: 'Fix',
        pending: 'Pending',
        delete: 'Deleted',
    }

    const validateChangeStatusForm = (lotDetails) => {
        if (!lotDetails.end_date || !dayjs(lotDetails.end_date).isValid()) {
            throwAlert('Please select valid End Date')
            return false
        }

        if (
            !lotDetails.end_time ||
            !dayjs(lotDetails.end_time, 'hh:mm:ss a').isValid()
        ) {
            throwAlert('Please select valid End Time')
            return false
        }

        if (!lotDetails.item_id) {
            throwAlert('Please enter a valid Item ID')
            return false
        }

        if (lotDetails.status === 'fix' || lotDetails.status === 'pending') {
            throwAlert('Cannot Move Item to Live until approved')
            return false
        }

        // if (!lotDetails.bprice) {
        //     throwAlert('Please enter a valid Buynow Price')
        //     return false
        // }

        // if (!lotDetails.asin_price) {
        //     throwAlert('Please enter a valid Retail Price')
        //     return false
        // }

        return true
    }

    const updateLotStatus = async (e, lotDetails, action) => {
        e.preventDefault()

        const isValidForm = validateChangeStatusForm(lotDetails)
        if (!isValidForm) return

        const endDate = dayjs(lotDetails.end_date).format('YYYY-MM-DD')
        const endTime = dayjs(lotDetails.end_time).isValid()
            ? dayjs(lotDetails.end_time).format('HH:mm:ss')
            : dayjs(lotDetails.end_time, 'hh:mm:ss a').isValid()
              ? dayjs(lotDetails.end_time, 'hh:mm:ss a').format('HH:mm:ss')
              : null

        const date_closed = dayjs(`${endDate}T${endTime}`).format(
            'YYYY-MM-DDTHH:mm:ssZ'
        )

        if (!dayjs(date_closed).isValid()) {
            throwAlert('Please select valid End Date and Time')
            return
        }

        // Added future date validation
        const now = dayjs()
        const selectedDateTime = dayjs(date_closed)

        if (selectedDateTime.isBefore(now)) {
            throwAlert('End Date and Time must be in the future')
            return
        }

        await Promise.all([
            changeStatusformik.setFieldValue('end_date', endDate),
            changeStatusformik.setFieldValue('end_time', endTime),
            changeStatusformik.setFieldValue('date_closed', date_closed),
            changeStatusformik.setFieldValue('action', action),
            changeStatusformik.setFieldValue('bprice', lotDetails.bprice),
            changeStatusformik.setFieldValue('project_id', lotDetails.id),
            changeStatusformik.setFieldValue('item_id', lotDetails.item_id),
            changeStatusformik.setFieldValue(
                'asin_price',
                lotDetails.asin_price
            ),
        ])

        console.log('changeStatusformik validation', changeStatusformik.values)
        changeStatusformik.handleSubmit()
    }

    const handleItemNumChange = (event) => {
        setItemNum(event.target.value)
        formik.setFieldValue(`limit`, event.target.value)
    }

    const handleInputChange = (val, id, field) => {
        // console.log(`productDetails `, val, `field `, field)
        setAllProducts((prevItems) =>
            prevItems.map((item) =>
                item.id === id ? { ...item, [field]: val } : item
            )
        )
    }

    const handleCheckBox = (event) => {
        const newState = {}
        for (let i = 0; i < allProducts.length; i++) {
            newState[i] = event.target.checked
        }
        setCheckboxes(newState)
    }

    const getCheckboxIDs = () =>
        allProducts.reduce((ids, productDetails, index) => {
            if (checkboxes[index]) {
                ids.push(productDetails.id)
            }
            return ids
        }, [])

    // console.log(getCheckboxIDs(), 'getCheckboxIDs')

    const onHandlePage = (event, value) => {
        formik.setFieldValue(`page`, value)
    }

    const handleFilterPopUp = () => {
        setFilterModal(true)
    }

    const handleFilterClose = () => {
        setFilterModal(!filterModal)
    }

    const handleTagsChange = (tags) => setItemTags(tags)

    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value)
    }

    const handleStaggerChange = (field, newValue) => {
        setSelectedStagger((prev) => ({
            ...prev,
            [field]: field === 'value' ? parseInt(newValue, 10) || 0 : newValue,
        }))
    }

    const throwAlert = (message) => {
        setAlert(message || 'Please select all required fields', 'error')
    }

    const handleBulkStatusChange = async (e) => {
        e.preventDefault()
        const projectIDs = getCheckboxIDs()
        if (projectIDs.length < 1) {
            throwAlert('Please select at least one lot')
            return
        }

        const status = String(selectedStatus || '').toLowerCase()
        if (status === 'live') {
            let errorMessage = ''

            const selectedProducts = allProducts.filter(({ id }) =>
                projectIDs.includes(id)
            )

            selectedProducts.some(({ id, status, end_date, end_time }) => {
                if (['fix', 'pending'].includes(status)) {
                    errorMessage =
                        'Cannot move selected lots to Live until all are approved'
                    return true
                }

                const endDate = dayjs(end_date).format('YYYY-MM-DD')
                const endTime = dayjs(end_time).isValid()
                    ? dayjs(end_time).format('HH:mm:ss')
                    : dayjs(end_time, 'hh:mm:ss a').isValid()
                      ? dayjs(end_time, 'hh:mm:ss a').format('HH:mm:ss')
                      : null

                const date_closed = dayjs(`${endDate}T${endTime}`).format(
                    'YYYY-MM-DDTHH:mm:ssZ'
                )

                const now = dayjs()
                const selectedDateTime = dayjs(date_closed)

                console.log(
                    `Validating product ${id}, date: ${date_closed}, now: ${now.format(
                        'YYYY-MM-DD HH:mm:ss'
                    )}`
                )

                if (selectedDateTime.isBefore(now)) {
                    errorMessage = 'End Date and Time must be in the future'
                    return true
                }

                return false
            })

            if (errorMessage) {
                throwAlert(errorMessage)
                return
            }
        }

        const payload = {
            action: 'statusUpdate',
            project_id: projectIDs,
            status: status === 'ready' ? 'live' : status,
            market_status: status === 'live' ? 'open' : 'draft',
            is_approved: status === 'live' ? 1 : 0,
            comments: '',
        }

        setIsLoading(true)
        multiProjectAction(payload, 'multiProjectAction', true)
    }

    const handleBulkEndTimeChange = (e) => {
        const projectIDs = getCheckboxIDs()
        if (projectIDs?.length > 0) {
            const endDate = dayjs(bulkClosedDate.end_date).isValid()
                ? dayjs(bulkClosedDate.end_date).format('YYYY-MM-DD')
                : null

            const endTime = dayjs(
                bulkClosedDate.end_time,
                ['HH:mm:ss', 'hh:mm:ss a'],
                true
            ).isValid()
                ? dayjs(
                      bulkClosedDate.end_time,
                      ['HH:mm:ss', 'hh:mm:ss a'],
                      true
                  ).format('HH:mm:ss')
                : null

            if (!endDate || !endTime) {
                throwAlert('Please select valid End Date and Time')
                return
            }

            const date_closed = dayjs(`${endDate}T${endTime}`).isValid()
                ? dayjs(`${endDate}T${endTime}`).format('YYYY-MM-DDTHH:mm:ssZ')
                : null

            console.log('Parsed endDate:', endDate, endTime, date_closed)

            if (!date_closed) {
                throwAlert('Please select valid End Date and Time')
                return
            }

            const payload = {
                action: 'endTimeUpdate',
                date_closed: date_closed,
                project_id: projectIDs,
                staggeredType: selectedStagger.type,
                staggeredValue: selectedStagger.value,
            }
            setIsLoading(true)
            multiProjectAction(payload, `multiProjectAction`, true)
        } else {
            throwAlert('Please select atleast one lot')
            return
        }
    }

    const handleBulkItemTagChange = (e) => {
        const projectIDs = getCheckboxIDs()
        if (projectIDs.length < 1) {
            throwAlert('Please select atleast one lot')
            return
        } else if (internalStatusFormik.values.keywords?.length < 1) {
            throwAlert('Please enter atleast one tag for the selected lots')
            return
        } else {
            const payload = {
                action: 'addKeywordTags',
                keywords: internalStatusFormik.values?.keywords?.toString(),
                project_id: projectIDs,
            }
            setIsLoading(true)
            multiProjectAction(payload, `multiProjectAction`, true)
        }
    }

    const getDraftExport = () => {
        const projectIDs = getCheckboxIDs()
        if (projectIDs?.length > 0) {
            getAllExportDownload({
                action: 'export',
                order: 'asc',
                filters: {
                    project_id: {
                        value: [...projectIDs],
                        field: 'p.id',
                        type: 'array',
                    },
                },
                orderby: '',
                search: 'all',
                report: `draft_product_management`,
            })
        } else {
            throwAlert('Please select atleast one lot')
            return
        }
    }

    const handleFilterChange = (
        category,
        value,
        isSingleSelect = false,
        checked
    ) => {
        switch (category) {
            case 'status':
                // formik.setFieldValue(
                //     'filters.status.value',
                //     internalStatusObject[value]
                // )
                // formik.setFieldValue(
                //     'filters.delete_status.value',
                //     value === 'Deleted Listings' ? '' : 'delete'
                // )
                if (checked) {
                    formik.values.filters.delete_status.value =
                        value === 'delete' ? '' : 'delete'
                    formik.values.filters.status.value.push(value)
                } else {
                    formik.values.filters.status.value =
                        formik.values.filters.status.value.filter(
                            (item) => item !== value
                        )
                    formik.values.filters.delete_status.value =
                        formik.values.filters.status.value.includes('delete')
                            ? ''
                            : 'delete'
                }
                break
            case 'sort':
                formik.setFieldValue('orderby', orderByObject[value])
                break
            case 'location':
                if (checked) {
                    formik.values.filters.location_id.value.push(value)
                } else {
                    formik.values.filters.location_id.value =
                        formik.values.filters.location_id.value.filter(
                            (item) => item !== value
                        )
                }
                break
            case 'processor':
                if (checked) {
                    formik.values.filters.employee_id.value.push(value)
                } else {
                    formik.values.filters.employee_id.value =
                        formik.values.filters.employee_id.value.filter(
                            (item) => item !== value
                        )
                }
                break
        }

        setSelectedFilters((prev) => {
            if (isSingleSelect) {
                return {
                    ...prev,
                    [category]: value,
                }
            } else {
                return {
                    ...prev,
                    [category]: {
                        ...prev[category],
                        [value]: !prev[category][value],
                    },
                }
            }
        })
    }

    useEffect(() => {
        if (!initialUpdate) {
            setIsLoading(true)
            setTimeout(() => {
                getProductsWithLatestFilters(from, true)
            }, 500)
        }
    }, [selectedFilters])

    const clearAllFormikFilters = () => {
        // console.log(`selectedFilters here`)
        formik.setFieldValue('filters.status.value', [])
        formik.setFieldValue('filters.delete_status.value', 'delete')
        formik.setFieldValue('orderby', 'p.created_at, asc')
        formik.setFieldValue('filters.location_id.value', [])
        formik.setFieldValue('filters.employee_id.value', [])
    }

    const clearAllSelections = () => {
        clearAllFormikFilters()
        setSelectedFilters({
            status: {},
            sort: '',
            // source: {},
            location: {},
            processor: {},
        })
    }

    const stripHtmlTags = (html) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = html
        return tempDiv.textContent || tempDiv.innerText || ''
    }

    const handleImageClick = (avatar, productImages, clickedIndex) => {
        setImages([
            // { main: avatar },
            ...productImages?.split(',')?.map((file) => ({
                main: isValidHttpUrl(file)
                    ? file
                    : `${global.images_url}${file}`,
            })),
        ])
        setImageIndex(clickedIndex)
        setImageZoomModal(true)
    }

    const keyWordTags = {
        formik: internalStatusFormik,
        data: [
            {
                label: 'Keywords',
                placeholder: 'Enter Keywords',
                class: 'col-12 keywordTagsCnt',
                type: 'tagsInput',
                name: 'keywords',
                options: [],
                filter: false,
                multiple: true,
                active: 1,
                view_page: 1,
            },
        ],
    }

    const Thead = () => (
        <thead>
            <tr>
                <th aria-label="Selection"></th>
                <th className="title">Title</th>
                <th>Photo(s)</th>
                <th>Description</th>
                <th>Price</th>
                <th>End Time</th>
                <th>Item ID</th>
                <th>Status</th>
            </tr>
        </thead>
    )

    return (
        <>
            <div className="listinTableBase_Root">
                <div className="tableFilter newDraft align-items-start">
                    <div className="d-flex align-items-start justify-content-start gap-3 flex-nowrap lfElements">
                        <Checkbox
                            {...label}
                            onChange={handleCheckBox}
                            checked={
                                Object.keys(checkboxes).length > 0 &&
                                Object.values(checkboxes).every(
                                    (value) => value
                                )
                            }
                        />
                        <div
                            className={`w-100 d-flex flex-wrap justify-content-start ${
                                personName == 'Update End Time'
                                    ? 'align-items-start'
                                    : 'align-items-center'
                            }`}
                            style={{
                                marginTop:
                                    personName == 'Update End Time'
                                        ? '-11px'
                                        : '0px',
                            }}
                        >
                            <div
                                className={`selectListOptions leftFilterOption  ${
                                    personName == 'Update End Time'
                                        ? 'endTimeCls'
                                        : ''
                                } `}
                            >
                                <FormControl sx={{ m: 1, width: 300, mt: 3 }}>
                                    <Select
                                        displayEmpty
                                        value={personName}
                                        onChange={(e) =>
                                            setPersonName(e.target.value)
                                        }
                                        input={<OutlinedInput />}
                                        renderValue={(selected) => {
                                            if (selected.length === 0) {
                                                return 'Action'
                                            }
                                            return selected
                                        }}
                                        MenuProps={{
                                            classes: {
                                                list: 'leftFilterSelect',
                                            },
                                            ...MenuProps,
                                        }}
                                        inputProps={{
                                            'aria-label': 'Without label',
                                        }}
                                    >
                                        {updateStatus.map((name) => (
                                            <MenuItem
                                                key={name}
                                                value={name}
                                                style={getStyles(
                                                    name,
                                                    personName,
                                                    theme
                                                )}
                                            >
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            {personName == 'Update Status' ? (
                                <>
                                    <div className="selectListOptions">
                                        <FormControl
                                            sx={{ m: 1, width: 300, mt: 3 }}
                                        >
                                            <Select
                                                displayEmpty
                                                value={selectedStatus}
                                                onChange={(e) => {
                                                    setSelectedStatus(
                                                        e.target.value
                                                    )
                                                }}
                                                input={<OutlinedInput />}
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return 'Live'
                                                    }
                                                    return selected
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight:
                                                                48 * 4.5 + 8,
                                                            width: 250,
                                                        },
                                                    },
                                                    MenuListProps: {
                                                        className:
                                                            'leftFilterSelect',
                                                    },
                                                }}
                                                inputProps={{
                                                    'aria-label':
                                                        'Select Status',
                                                }}
                                                className="updateFormControl"
                                            >
                                                {inventoryStatus.map(
                                                    (status) => (
                                                        <MenuItem
                                                            key={status}
                                                            value={status}
                                                            style={getStyles(
                                                                status,
                                                                selectedStatus,
                                                                theme
                                                            )}
                                                        >
                                                            {status}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <Button
                                            className="primaryButton"
                                            // style={{ minWidth: '135px' }}
                                            onClick={async (e) =>
                                                await handleBulkStatusChange(e)
                                            }
                                        >
                                            Go
                                        </Button>
                                    </div>
                                </>
                            ) : personName == 'Update End Time' ? (
                                <div
                                    className="d-flex align-items-start justify-content-start flex-wrap endTimeSlot"
                                    style={{ marginTOp: '-20px' }}
                                >
                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                    >
                                        <div className="tableCerseInput endTimeCnt">
                                            <small>Update end time :</small>
                                            <DatePicker
                                                disablePast
                                                value={dayjs(
                                                    bulkClosedDate.end_date,
                                                    'YYYY-MM-DD'
                                                )}
                                                onChange={(newDate) =>
                                                    handleBulkDateChange(
                                                        'end_date',
                                                        newDate
                                                    )
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select end date"
                                                        InputProps={{
                                                            endAdornment: (
                                                                <span className="material-icons-outlined">
                                                                    calendar_month
                                                                </span>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                        <div className="tableCerseInput endTimeCnt second">
                                            <small></small>
                                            <TimePicker
                                                value={dayjs(
                                                    bulkClosedDate.end_time,
                                                    'HH:mm:ss'
                                                )}
                                                onChange={(newTime) =>
                                                    handleBulkDateChange(
                                                        'end_time',
                                                        newTime
                                                    )
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select end date"
                                                        InputProps={{
                                                            endAdornment: (
                                                                <span className="material-icons-outlined">
                                                                    schedule
                                                                </span>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                    <div className="tableCerseInput staggerCnt">
                                        <small>Stagger :</small>
                                        <div className="staggerInput">
                                            <CustomInput
                                                onChange={(e) =>
                                                    handleStaggerChange(
                                                        'value',
                                                        e.target.value
                                                    )
                                                }
                                                value={selectedStagger.value}
                                            />
                                            <Select
                                                value={selectedStagger.type}
                                                onChange={(e) =>
                                                    handleStaggerChange(
                                                        'type',
                                                        e.target.value
                                                    )
                                                }
                                                displayEmpty
                                                IconComponent={() => null}
                                                style={{
                                                    border: 'none',
                                                    background: 'transparent',
                                                }}
                                            >
                                                <MenuItem value="days">{`DAY(S)`}</MenuItem>
                                                <MenuItem value="hours">{`HOUR(S)`}</MenuItem>
                                                <MenuItem value="mins">{`MIN(S)`}</MenuItem>
                                                <MenuItem value="seconds">{`SECOND(S)`}</MenuItem>
                                            </Select>
                                        </div>
                                    </div>
                                    <Button
                                        onClick={(e) =>
                                            handleBulkEndTimeChange(e)
                                        }
                                        className="primaryButton endTimeBtn"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            ) : personName == 'Keyword Tags' ? (
                                <div className="d-flex align-items-center justify-content-start flex-wrap keyWordCnt">
                                    <div className="row">
                                        {mapData(keyWordTags)}
                                    </div>
                                    {/* <TagsInput
                                        value={itemTags}
                                        onChange={handleTagsChange}
                                    />*/}
                                    <Button
                                        onClick={(e) =>
                                            handleBulkItemTagChange(e)
                                        }
                                        className="primaryButton endTimeBtn"
                                    >
                                        Add
                                    </Button>
                                </div>
                            ) : personName == 'Export' ? (
                                <div
                                    className="d-flex align-items-start justify-content-start flex-wrap"
                                    style={{ marginTOp: '-20px' }}
                                >
                                    <Button
                                        id="listingDynamic_report"
                                        // variant="outlined"
                                        className="btnOutlined"
                                        onClick={() => getDraftExport()}
                                    >
                                        <span className="material-icons-outlined">
                                            file_download
                                        </span>
                                        Export
                                    </Button>
                                </div>
                            ) : null}
                            <small
                                className={`${
                                    personName == 'Update End Time'
                                        ? 'endTimeCount'
                                        : ''
                                } selectedItemCount`}
                            >
                                (
                                {
                                    Object.values(checkboxes).filter(Boolean)
                                        .length
                                }{' '}
                                selected)
                            </small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 flex-nowrap rtElements">
                        <div className="selectListOptions">
                            <div className="itemPageDraft">
                                <p className="m-0">Item Per Page</p>
                            </div>
                            <FormControl sx={{ m: 1, width: 300, mt: 3 }}>
                                <Select
                                    displayEmpty
                                    value={formik.values.limit}
                                    onChange={handleItemNumChange}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return '10'
                                        }
                                        return selected
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200,
                                            },
                                        },
                                    }}
                                    inputProps={{
                                        'aria-label': 'Without label',
                                    }}
                                >
                                    {['10', '20', '60', '100'].map((value) => (
                                        <MenuItem
                                            key={value}
                                            value={value}
                                            style={getStyles(
                                                value,
                                                itemNum,
                                                theme
                                            )}
                                        >
                                            {value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div
                            className="d-flex align-items-center justify-content-center gap-3 flex-nowrap rtFilterSpan"
                            onClick={handleFilterPopUp}
                        >
                            <img src="/assets/svg/filter_draft.svg" />
                            {/* <span className="material-icons-outlined">
                                filter_list
                            </span> */}
                            Filters
                        </div>
                    </div>
                </div>
                <div className="table-responsive listingTableFrameBox">
                    {isLoading ? (
                        <Loaders name={`table`} isLoading={isLoading} />
                    ) : (
                        <>
                            <table className="table">
                                <Thead />
                                {allProducts.map((productDetails, index) => (
                                    <tbody>
                                        <tr
                                            className={
                                                checkboxes[index]
                                                    ? 'row-highlight'
                                                    : ''
                                            }
                                            ref={(el) =>
                                                (rowRefs.current[index] = el)
                                            }
                                        >
                                            <td>
                                                <Checkbox
                                                    {...label}
                                                    checked={
                                                        checkboxes[index] ||
                                                        false
                                                    }
                                                    onChange={() => {
                                                        setCheckboxes(
                                                            (prev) => ({
                                                                ...prev,
                                                                [index]:
                                                                    !prev[
                                                                        index
                                                                    ],
                                                            })
                                                        )
                                                    }}
                                                />
                                            </td>
                                            <td
                                                className="title"
                                                onClick={() =>
                                                    handleModalChanges(
                                                        productDetails
                                                    )
                                                }
                                            >
                                                {productDetails.title}
                                            </td>
                                            <td>
                                                <div
                                                    className="imgCollageBox"
                                                    // onClick={() =>
                                                    //     handleModalChanges(
                                                    //         productDetails
                                                    //     )
                                                    // }
                                                >
                                                    <img
                                                        src={
                                                            isValidHttpUrl(
                                                                productDetails.avatar
                                                            )
                                                                ? productDetails.avatar
                                                                : `${global.images_url}${productDetails.avatar}`
                                                        }
                                                        alt={
                                                            productDetails.title
                                                        }
                                                        className="large"
                                                        onError={(e) =>
                                                            (e.target.src =
                                                                '/assets/images/noimage.png')
                                                        }
                                                        onClick={() => {
                                                            handleImageClick(
                                                                isValidHttpUrl(
                                                                    productDetails.avatar
                                                                )
                                                                    ? productDetails.avatar
                                                                    : `${global.images_url}${productDetails.avatar}`,
                                                                productDetails.uploadimages,
                                                                0
                                                            )
                                                        }}
                                                    />

                                                    <div className="imglittlefingerBox">
                                                        {productDetails.uploadimages ? (
                                                            String(
                                                                productDetails.uploadimages
                                                            )
                                                                .split(',')
                                                                .slice(1)
                                                                .map(
                                                                    (
                                                                        file,
                                                                        idx
                                                                    ) => (
                                                                        <img
                                                                            key={
                                                                                idx
                                                                            }
                                                                            src={
                                                                                isValidHttpUrl(
                                                                                    file
                                                                                )
                                                                                    ? file
                                                                                    : `${global.images_url}${file}`
                                                                            }
                                                                            className="small"
                                                                            alt={
                                                                                productDetails.title
                                                                            }
                                                                            onError={(
                                                                                e
                                                                            ) =>
                                                                                (e.target.src =
                                                                                    '/assets/images/noimage.png')
                                                                            }
                                                                            onClick={() => {
                                                                                handleImageClick(
                                                                                    isValidHttpUrl(
                                                                                        productDetails.avatar
                                                                                    )
                                                                                        ? productDetails.avatar
                                                                                        : `${global.images_url}${productDetails.avatar}`,
                                                                                    productDetails.uploadimages,
                                                                                    idx +
                                                                                        1
                                                                                )
                                                                            }}
                                                                        />
                                                                    )
                                                                )
                                                        ) : (
                                                            <img
                                                                src="/assets/images/noimage.png"
                                                                className="small"
                                                                alt="thumbnail"
                                                            />
                                                        )}
                                                    </div>

                                                    {imageZoomModal && (
                                                        <ImageZoom
                                                            imageZoomModal={
                                                                imageZoomModal
                                                            }
                                                            toggleImage={(
                                                                direction
                                                            ) => {
                                                                setImageIndex(
                                                                    (prev) =>
                                                                        direction ===
                                                                        'prev'
                                                                            ? prev -
                                                                              1
                                                                            : prev +
                                                                              1
                                                                )
                                                            }}
                                                            images={images}
                                                            imageIndex={
                                                                imageIndex
                                                            }
                                                            setImageZoomModal={
                                                                setImageZoomModal
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </td>
                                            <td className="description descriptionShowMore">
                                                {/* <ShowMoreText lines={3}> */}
                                                {/* <Linkify> */}
                                                {/* <p
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            stripHtmlTags(
                                                                productDetails.desc_proc
                                                            ).length > 250
                                                                ? `${stripHtmlTags(
                                                                      productDetails.desc_proc
                                                                  ).substring(
                                                                      0,
                                                                      250
                                                                  )}...`
                                                                : productDetails.desc_proc,
                                                    }}
                                                ></p>
                                                <p></p>
                                                {stripHtmlTags(
                                                    productDetails.desc_proc
                                                ).length > 250 && (
                                                    <Button
                                                        onClick={() =>
                                                            handleModalChanges(
                                                                productDetails
                                                            )
                                                        }
                                                    >
                                                        Show More
                                                    </Button>
                                                )} */}
                                                <LineClampItem
                                                    key={index}
                                                    lineClamp={'5'}
                                                    productDetails={
                                                        productDetails
                                                    }
                                                    handleFunction={
                                                        handleModalChanges
                                                    }
                                                    name="desc_proc"
                                                />
                                                {/* </Linkify> */}
                                                {/* </ShowMoreText> */}
                                            </td>
                                            <td>
                                                <div className="TextGridListSas">
                                                    <div className="tableCerseInput">
                                                        <small>Retail :</small>
                                                        <CustomInput
                                                            placeholder=""
                                                            type={`number`}
                                                            value={
                                                                productDetails.asin_price
                                                            }
                                                            onChange={(e) => {
                                                                handleInputChange(
                                                                    e.target
                                                                        .value,
                                                                    productDetails.id,
                                                                    `asin_price`
                                                                )
                                                            }}
                                                            // startAdornment={
                                                            //     <span className="material-icons-outlined">
                                                            //         attach_money
                                                            //     </span>
                                                            // }
                                                        />
                                                    </div>
                                                    <div className="tableCerseInput buyNowInputListing">
                                                        <small>Buy Now :</small>
                                                        <CustomInput
                                                            placeholder=""
                                                            type={`number`}
                                                            value={
                                                                productDetails.bprice
                                                            }
                                                            onChange={(e) => {
                                                                handleInputChange(
                                                                    e.target
                                                                        .value,
                                                                    productDetails.id,
                                                                    `bprice`
                                                                )
                                                            }}
                                                            endAdornment={
                                                                productDetails.qty >
                                                                1 ? (
                                                                    <Tooltip
                                                                        title="Quantity"
                                                                        arrow
                                                                    >
                                                                        <InputAdornment
                                                                            position="end"
                                                                            className="pr-2"
                                                                        >
                                                                            <span>
                                                                                *
                                                                                {
                                                                                    productDetails.qty
                                                                                }
                                                                            </span>
                                                                        </InputAdornment>
                                                                    </Tooltip>
                                                                ) : null
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="timerDateTd">
                                                <LocalizationProvider
                                                    dateAdapter={AdapterDayjs}
                                                >
                                                    <div className="TextGridListSas">
                                                        {/* End Date Picker */}
                                                        <div className="tableCerseInput">
                                                            <small>
                                                                End date:
                                                            </small>
                                                            <DatePicker
                                                                disablePast
                                                                value={dayjs(
                                                                    productDetails.date_closed
                                                                )}
                                                                onChange={(
                                                                    newDate
                                                                ) => {
                                                                    handleInputChange(
                                                                        newDate,
                                                                        productDetails.id,
                                                                        `end_date`
                                                                    )
                                                                }}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select end date"
                                                                        InputProps={{
                                                                            endAdornment:
                                                                                (
                                                                                    <span className="material-icons-outlined">
                                                                                        calendar_month
                                                                                    </span>
                                                                                ),
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </div>

                                                        {/* End Time Picker */}
                                                        <div className="tableCerseInput">
                                                            <small>
                                                                End time:
                                                            </small>
                                                            <TimePicker
                                                                value={dayjs(
                                                                    productDetails.date_closed
                                                                )}
                                                                onChange={(
                                                                    newTime
                                                                ) => {
                                                                    handleInputChange(
                                                                        newTime,
                                                                        productDetails.id,
                                                                        `end_time`
                                                                    )
                                                                }}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select end time"
                                                                        InputProps={{
                                                                            endAdornment:
                                                                                (
                                                                                    <span className="material-icons-outlined">
                                                                                        schedule
                                                                                    </span>
                                                                                ),
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                </LocalizationProvider>
                                            </td>
                                            <td className="itemFieldBox">
                                                <div className="TextGridListSas">
                                                    <div className="tableCerseInput itsALIGN">
                                                        <small>Item ID:</small>
                                                        <CustomInput
                                                            placeholder="Enter Item ID"
                                                            value={
                                                                productDetails
                                                                    ?.item_id
                                                                    ?.length >
                                                                15
                                                                    ? productDetails?.item_id
                                                                    : productDetails?.item_id
                                                            }
                                                            onChange={(e) => {
                                                                handleInputChange(
                                                                    e.target
                                                                        .value,
                                                                    productDetails.id,
                                                                    `item_id`
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="tableCerseButton">
                                                        <Button
                                                            variant="filled"
                                                            className="btnOutlined mr-2"
                                                            onClick={() =>
                                                                onClickPreview(
                                                                    productDetails.id
                                                                )
                                                            }
                                                        >
                                                            Preview
                                                        </Button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="itemFieldBox finaltdCell">
                                                <div className="TextGridListSas">
                                                    <div className="tableCerseButton">
                                                        <Button
                                                            variant="filled"
                                                            disabled={
                                                                productDetails.status ===
                                                                'delete'
                                                            }
                                                            className={`btnOutlined mr-2 ${
                                                                productDetails.status ===
                                                                'fix'
                                                                    ? 'bg-danger'
                                                                    : productDetails.status ===
                                                                        'pending'
                                                                      ? 'bg-warning'
                                                                      : ''
                                                            }`}
                                                            onClick={(e) =>
                                                                changeCommentPopup(
                                                                    e,
                                                                    productDetails.id,
                                                                    productDetails.status,
                                                                    productDetails
                                                                )
                                                            }
                                                        >
                                                            {
                                                                statusString[
                                                                    productDetails.status ||
                                                                        'live'
                                                                ]
                                                            }
                                                        </Button>
                                                    </div>
                                                    <div className="tableCerseButton">
                                                        <Button
                                                            variant="filled"
                                                            className={`btnOutlined mr-2 ${
                                                                productDetails.is_approved
                                                                    ? 'bg-success'
                                                                    : ''
                                                            }`}
                                                            disabled={
                                                                productDetails.status ===
                                                                    'delete' ||
                                                                (user?.emp_type?.toLowerCase() !==
                                                                    'seller' &&
                                                                    !isAdmin)
                                                            }
                                                            onClick={(e) =>
                                                                updateLotStatus(
                                                                    e,
                                                                    productDetails,
                                                                    'open'
                                                                )
                                                            }
                                                        >
                                                            <>
                                                                {productDetails.is_approved
                                                                    ? 'Ready'
                                                                    : 'Send Live'}
                                                            </>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ))}
                            </table>
                        </>
                    )}
                </div>
                <div
                    className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper"
                    id="search_pagination"
                >
                    <h6>
                        {all_products.totalRecords > 0 ? (
                            <>
                                {'Showing'} {all_products.setDisp} {'of'}{' '}
                                {all_products.totalRecords || 0}
                            </>
                        ) : null}
                    </h6>
                    {props.pagination ? (
                        <Pagination
                            count={Math.ceil(
                                all_products.totalRecords / formik.values.limit
                            )}
                            page={formik.values.page}
                            onChange={onHandlePage}
                            siblingCount={3}
                            showFirstButton
                            showLastButton
                            boundaryCount={2}
                        />
                    ) : null}
                </div>
            </div>
            {/* {filterModal ? ( */}
            <FilterModal
                open={filterModal}
                allEmployees={all_employees?.records || []}
                selectedFilters={selectedFilters}
                handleClose={handleFilterClose}
                clearAllSelections={clearAllSelections}
                handleFilterChange={handleFilterChange}
            />
            {/* ) : null} */}
            {/* {editModal ? ( */}
            <EditModal
                open={editModal}
                prev_id={prevID}
                next_id={nextID}
                handleClose={() =>
                    handleClickMyModal(allProducts.indexOf(productDetails))
                }
                productDetails={productDetails}
            />
            {/* ) : null} */}
            <CommentModal
                open={commentPopup}
                internalStatusObj={internalStatusObj}
                closeCommentPopup={closeCommentPopup}
                changeCommentPopup={changeCommentPopup}
            />
            {/* <CustomDialog
                title={'Comments'}
                open={commentPopup}
                className={`lotNotes`}
                function={changeCommentPopup}
                closeBtn={() => {
                    internalStatusFormik.setFieldValue('notes', '')
                    setCommentPopup(false)
                }}
            >
                <div>
                    <form
                        onSubmit={internalStatusFormik.handleSubmit}
                        autoComplete="nofill"
                    >
                        {mapData(commentsData)}
                        <div className="text-center">
                            <PrimaryButton
                                id="inventory_update"
                                type="submit"
                                label="Confirm"
                            />
                        </div>
                    </form>
                </div>
            </CustomDialog> */}
        </>
    )
}

export default ListingTable
